export default __webpack_public_path__ + "static/eeuu-f692a024d654db7f170228af4070eb02.jpg";